import Chip from '@mui/material/Chip';

import { ROTULOS_DE_ESTADO_DA_LINHA, type EstadoDaLinha } from './api/tipos';

/** Mesma disciplina de `SeloDeEstadoDaConferencia.tsx`. `barrado` é o único que trava o lote (`S12`). */
const TOM: Record<EstadoDaLinha, 'ok' | 'atencao' | 'estourado' | 'semPrazo'> = {
  ok: 'ok',
  alerta: 'atencao',
  barrado: 'estourado',
  sem_cobertura: 'semPrazo',
  desconhecido: 'semPrazo',
};

export function SeloDeEstadoDaLinha({ estado }: { estado: EstadoDaLinha }): React.JSX.Element {
  return (
    <Chip
      size="small"
      label={ROTULOS_DE_ESTADO_DA_LINHA[estado]}
      sx={(tema) => {
        const tom = tema.palette.sla[TOM[estado]];
        return {
          backgroundColor: tom.fundo,
          color: tom.tinta,
          border: `1px solid ${tom.borda}`,
          fontWeight: 600,
          height: 20,
        };
      }}
    />
  );
}
